import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-634f7242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { slot: "start" }, "Videos", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { slot: "start" }, "Players", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { slot: "start" }, "Tracker", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { slot: "start" }, "Shared", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { slot: "start" }, "Settings", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_icon, {
      icon: _ctx.close,
      class: "close",
      onClick: _ctx.closeMenu
    }, null, 8, ["icon", "onClick"]),
    _createVNode(_component_ion_header, { class: "ion-no-border" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { color: "primary" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Game Tracker")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_list, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, { to: '/tabs/home' }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: _normalizeClass(_ctx.activeRoute == '/tabs/home' ? 'active' : 'inactive')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.videocam
                }, null, 8, ["icon"]),
                _hoisted_2
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: '/tabs/players' }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: _normalizeClass(_ctx.activeRoute == '/tabs/players' ? 'active' : 'inactive')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.peopleCircle
                }, null, 8, ["icon"]),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: '' }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: _normalizeClass(_ctx.activeRoute == '/tracking' ? 'active' : 'inactive')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.peopleCircle
                }, null, 8, ["icon"]),
                _hoisted_4
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: '/tabs/shared' }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: _normalizeClass(_ctx.activeRoute == '/tabs/shared' ? 'active' : 'inactive')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.share
                }, null, 8, ["icon"]),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: '/tabs/settings' }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              lines: "none",
              class: _normalizeClass(_ctx.activeRoute == '/tabs/settings' ? 'active' : 'inactive')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.cog
                }, null, 8, ["icon"]),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}